"use client";

import { truncate } from "lodash";
import { cn } from "@/app/_utils/cn";
import { Badge } from "@/app/admin/_common/ui/badge";
import { FileText, Plus } from "lucide-react";

interface TemplatePickerCardProps {
  selected: boolean;
  onClick: () => void;
  title: string;
  thumbnail?: string | null;
  isSample?: boolean;
  blank?: boolean;
}

export default function TemplatePickerCard({
  selected,
  onClick,
  title,
  thumbnail,
  isSample,
  blank,
}: TemplatePickerCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex h-[180px] w-[140px] flex-none flex-col overflow-hidden rounded-md border border-border bg-card text-left hover:border-primary/40",
        selected && "border-2 border-primary"
      )}
    >
      <div className="flex min-h-0 flex-1 items-center justify-center overflow-hidden bg-muted/40">
        {blank ? (
          <Plus className="size-10 text-primary/30" />
        ) : thumbnail ? (
          <img src={thumbnail} alt={title} className="size-full object-cover" />
        ) : (
          <FileText className="size-10 text-primary/30" />
        )}
      </div>
      <div className="flex flex-none items-center gap-1 border-t border-border p-2">
        <span title={title} className="min-w-0 truncate text-[12.5px] text-foreground">
          {truncate(title, { length: 18 })}
        </span>
        {isSample && (
          <Badge variant="outline" className="h-[18px] flex-none px-1.5 text-[10px] font-normal">
            Starter
          </Badge>
        )}
      </div>
    </button>
  );
}
